import { Eyebrow, ChromeHeading, GoldText, Countdown, PulseCTA, Diamond } from "../funnel";
import { Ticket } from "./Ticket";

const AUDIENCE = ["For business owners", "9-to-5 pros building a business", "Service pros"];

export const Hero = () => (
  <section className="relative overflow-hidden" data-testid="hero-section">
    <div className="breathe-glow pointer-events-none absolute left-1/2 top-10 h-[620px] w-[min(1100px,140vw)] -translate-x-1/2" aria-hidden="true" />
    <div className="gutter relative flex flex-col items-center pb-20 pt-12 text-center sm:pt-16 lg:pb-28">
      <p className="fade-up inline-flex max-w-full flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-full border border-[rgba(232,184,74,0.35)] bg-black/40 px-4 py-2 text-[12px] text-[#e6dcc6] sm:text-[13px]" data-testid="hero-audience-pill">
        {AUDIENCE.map((a, i) => (
          <span key={a} className="inline-flex items-center gap-2">
            {i > 0 && <Diamond className="text-[8px]" />}
            {a}
          </span>
        ))}
      </p>
      <Eyebrow ruled className="fade-up mt-8 [animation-delay:80ms]" data-testid="hero-eyebrow">WEAPONIZED CREDIT TO CAPITAL</Eyebrow>
      <ChromeHeading as="h1" className="fade-up mt-5 max-w-5xl text-[40px] [animation-delay:160ms] sm:text-6xl lg:text-7xl" data-testid="hero-headline">
        Give me 90 minutes live and I'll show you how business owners are turning their credit into <GoldText>$100K+ in funding</GoldText>
      </ChromeHeading>
      <p className="fade-up mt-6 max-w-2xl text-[15px] leading-relaxed text-[#cfc7b6] [animation-delay:240ms] sm:text-lg" data-testid="hero-subheadline">
        Without perfect credit, without putting your house up as collateral, and without burning inquiries on banks that were always going to say no.
      </p>
      <div className="fade-up mt-8 flex items-center gap-3 text-left [animation-delay:320ms]" data-testid="hero-host">
        <img src="/assets/jay-portrait.jpg" alt="Jay Shelton" className="h-14 w-14 shrink-0 rounded-full object-cover object-[50%_25%] ring-2 ring-[var(--gold)] ring-offset-2 ring-offset-[#0a0a0a]" />
        <div>
          <p className="font-serif-it text-xl text-[#f4efe4]">Hosted by Jay Shelton</p>
          <p className="font-mono-plex text-[10.5px] uppercase tracking-[0.16em] text-[var(--gold)] sm:text-[11px]">Founder, J11 · Educate II Elevate</p>
        </div>
      </div>
      <Countdown className="fade-up mt-10 [animation-delay:400ms]" />
      <div className="fade-up mt-8 w-full [animation-delay:480ms] sm:w-auto">
        <PulseCTA className="w-full sm:w-auto" data-testid="hero-cta-button" />
      </div>
      <Ticket />
    </div>
  </section>
);
